module.exports = __webpack_public_path__ + "img/CZ.ee13d5ba.svg";